import { useState } from "react";
import { useHistory } from "react-router-dom";
import useUrlState from "@ahooksjs/use-url-state";

import orders from "configs/orders";
import GenericHeader from "../../../components/GenericHeader/GenericHeader";
import GenericTable from "../../../components/GenericTable/GenericTable";

import Box from "@mui/material/Box";

import placeholderPic from "../../../assets/no_data_x.gif";
import { useApiHook } from "providers/ApiProvider";

const OrdersTableView = () => {
  const history = useHistory();

  const [selectedRows, setSelectedRows] = useState([]);
  const [queryParams, setQueryParams] = useUrlState({
    // q: undefined,
    page: 0,
    size: 10,
    // sortBy: "created_at",
    // sortDirection: "desc",
  });

  // const [searchQuery, setSearchQuery] = useState(
  //   localStorage.getItem("searchQuery") || ""
  // );

  // const permissionChecker = usePermissionChecker();

  const query = {
    // q: searchQuery ?? "",
    page: Number(queryParams.page) + 1,
    size: queryParams.size,
    // _sort: queryParams.sortBy ?? "created_at",
    // _order: queryParams.sortDirection ?? "desc",
  };

  const orderData = useApiHook("Orders", "getAllResources", { query });

  // const handleSearch = (value: string) => {
  //   localStorage.setItem("searchQuery", value);
  //   setSearchQuery(value);

  //   if (queryParams.q !== value) {
  //     setQueryParams({ q: value, page: 0 });
  //   } else {
  //     setQueryParams({ q: value });
  //   }
  // };

  // const deleteOrder = () => {
  //   if (!permissionChecker("delete-order", true)) return;

  //   setLoading(true);

  //   ordersClient
  //     .deleteManyResource({ data: selectedRows })
  //     .then(() => fetchData())
  //     .finally(() => setLoading(false));
  // };

  const rowTriggerAction = (row: any) => {
    history.push(`orders/${row?.id}`);
  };

  const handlePageChange = (e: any, value: any) => {
    setQueryParams({ page: value });
  };

  const handleRowsChange = (e: { target: { value: string } }) => {
    setQueryParams({ page: 0, size: parseInt(e.target.value) });
  };

  const handleRowSelectionChange = (data: any) => {
    setSelectedRows(data);
  };

  // const onColumnSort = (c: any) => {
  //   if (queryParams.sortBy === c) {
  //     setQueryParams((s) => ({
  //       sortDirection: s.sortDirection === "asc" ? "desc" : "asc",
  //     }));
  //   } else {
  //     setQueryParams({ sortBy: c, sortDirection: "asc" });
  //   }
  // };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        maxHeight: "100vh",
        overflow: "scroll",
      }}
    >
      <GenericHeader
        // onSearch={handleSearch}
        // addResourceHandler={navigateToAddPage}
        // deleteResourceHandler={deleteOrder}
        selectedRows={selectedRows}
        model="order"
      />
      <div className="p-4">
        <h2 className="mb-4">Orders</h2>
        <GenericTable
          showCheckbox={false}
          frontendPagination={true}
          list={orderData?.data?.data ? orderData?.data?.data : []}
          totalCount={orderData?.data?.data?.length || 0}
          onSelectedChange={handleRowSelectionChange}
          selectedRows={selectedRows}
          page={Number(queryParams.page)}
          loading={orderData.loading}
          rowsPerPage={Number(queryParams.size)}
          onRowsChange={handleRowsChange}
          onPageChange={handlePageChange}
          image={placeholderPic}
          tableConfig={orders}
          model="order"
          passRow={rowTriggerAction}
          // columnSort={queryParams.sortBy}
          // columnSortDir={queryParams.sortDirection}
          // onColumnSort={onColumnSort}
        />
      </div>
    </Box>
  );
};

export default OrdersTableView;
